/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box, Typography} from '@mui/material';
import {cloneDeep} from 'lodash';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import {useRouter} from 'next/router';
import {useEffect, useMemo, useRef, useState} from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import VerticalScrollingThumbnailCardOrganisms from '~/components/wrapper/organisms/scrolling-infinity-thumbnail-card';
import ScrollingNewsFilterOrganisms from '~/components/wrapper/organisms/scrolling-news-filter';
import {usePageSetting} from '~/providers/page-context.provider';
import {dateArithmetic, handleConvertToLocaleContentful, handleTranslateNews} from '~/utils';
import {handleGetDataNews} from '~/utils/button-functions';
import * as Types from '../../graphql/types';
import {getPageData} from '../[[...slug]]/index.page';
import {DATA_FILTER_GAME} from './constantDataConvert';
import getListNew from './get-news-by-tag';
import NotFoundOrganisms from '~/components/wrapper/organisms/not-found';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {GLOBAL_TYPE, NEWS_LISTING_SOURCE} from '~/constants/content-map-type';
import {getGloablByType} from '~/utils/global-operations';

type PageGetNewsExt = {
  listTags: any;
  data: any;
  dataWhatsOn: Types.NewsCollection;
  dataTipsAndTricks: Types.NewsCollection;
  locale: string;
};

const News = (props: PageGetNewsExt) => {
  const {listTags, data, dataWhatsOn, dataTipsAndTricks, locale} = props;
  // console.log('News data33',data)
  const page = data?.pageCollection?.items[0];
  const router = useRouter();

  const [dataFilterSelected, setDataFilterSelected] = useState<any[]>([]);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [dataQueryTags, setDataQueryTags] = useState<string[]>([]);
  const [dataQueryGame, setDataQueryGame] = useState<string>('');
  const [dataSlugActivate, setDataSlugActivate] = useState<string>('');
  const [titleGame, setTitleGame] = useState<string>('');
  const [titleTag, setTitleTag] = useState<string>('');
  const [tabGame, setTabGame] = useState<string>('');

  const refDataTranslation = useRef<any>({});
  const refListTagsColor = useRef<any>({});
  const firstRenderRef = useRef(true);

  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const dataTranslationEnGn = globalData?.dataTranslation?.[1] ?? {};
  const listTagsColor = globalData?.listTagsColor ?? [];

  useEffect(() => {
    if (dataFilterSelected.length) {
      setIsFilter(true);
    }
  }, [dataFilterSelected]);

  useEffect(() => {
    if (dataQueryTags.length || !!dataQueryGame) {
      setIsFilter(true);
      setDataFilterSelected(['1']);
    } else {
      setIsFilter(false);
    }

    if (typeof window !== 'undefined') {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }, [dataQueryTags, dataQueryGame]);

  let tag = router.query?.tag || null;
  if (typeof tag === 'string') {
    tag = tag.split('-');
  }
  const title = router.query?.title || '';
  const tab = router.query?.t || '';

  const gameCat = Array.isArray(router.query?.game) ? router.query.game[0] : router.query?.game || ''

// console.log('dataSlugActivate80',dataSlugActivate)
  useEffect(() => {
    if (firstRenderRef.current) {
      // console.log('firstRenderRef.current',firstRenderRef.current)
      // console.log('firstRenderRef.current gamecat',gameCat)
      firstRenderRef.current = false;
      return;
    }
    // console.log('dataSlugActivate92', dataSlugActivate);
    const { tag, ...otherQueries } = router.query;
    if(!tag) return
    router.push({
      pathname: router.pathname,
      query: {
        ...otherQueries,
        game: dataSlugActivate,
        ...(tag && { tag })
      }
    });
  }, [dataSlugActivate]);


  const handleTranslateBlogTagsToEnSg = (tags: any[]): any[] => {
    const result: any[] = [];
    const keyTag: any[] = [];

    if (tags?.length) {
      tags.map((tag: string) => {
        for (const [key, value] of Object.entries(dataTranslation)) {
          if ((value as string)?.trim()?.toLowerCase() === tag?.trim().toLowerCase()) {
            keyTag.push(key);
          }
        }
      });
    }

    if (keyTag.length) {
      keyTag.map(key => {
        if (dataTranslationEnGn[key]) {
          const value = dataTranslationEnGn[key]?.toLowerCase();
          result.push(DATA_FILTER_GAME[value]);
        }
      });
    }
    return result;
  };

  // get value filter tag
  useEffect(() => {
    refDataTranslation.current = dataTranslation;
    refListTagsColor.current = listTagsColor;
    if (tag && typeof tag === 'object') {
      setDataQueryTags([...handleTranslateBlogTagsToEnSg(tag)]);
    }
    // set title tag when query fo tag
    const titleTag = router.query?.tag as string;
    if (titleTag === 'Tips and tricks') {
      setTitleTag('Tips & tricks');
    } else {
      setTitleTag(titleTag);
    }
  }, [JSON.stringify(tag), dataTranslation, listTagsColor]);

  // get value filter title game
  useEffect(() => {
    refDataTranslation.current = dataTranslation;
    refListTagsColor.current = listTagsColor;
    if (title) {
      setTitleGame(
        `${title} - ${
          tab === '1'
            ? dataTranslation?.['title-all-news'] ?? ''
            : dataTranslation?.['title-all-patch-notes']
          // dataTranslation['game-detailed-explore-more-patch-notes']
        }`
      );
      // console.log('setDataQueryGame 133',title)
      setDataQueryGame(title as string);
    }
    if (tab) {
      // console.log('tab135',tab)
      setTabGame(tab as string);
    }
  }, [JSON.stringify(title), JSON.stringify(tab), dataTranslation, listTagsColor]);

  const block: Array<any> = [page.sectionCollection?.items, page.seoStandard].filter(
    block => !!block
  );

  // Data of ScrollingThumbnailCard
  const blockCopy = cloneDeep(block);
  blockCopy[0].map((section: any, idx: number) => {
    if (blockCopy[0][idx].blocksCollection?.items[0]) {
      blockCopy[0][idx].blocksCollection.items[0] = {
        ...blockCopy[0][idx].blocksCollection.items[0],
        dataTranslation: dataTranslation,
      };
    }

    blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
      ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
      items: handleTranslateNews(
        blockCopy[0][idx].blocksCollection.items[0].listItemCollection.items,
        dataTranslation
      ),
      listTags: listTagsColor,
    };

    if (section?.blocksCollection?.items[0]?.type === 'ScrollingNewsFilter') {
      blockCopy[0][idx].blocksCollection.items[0] = {
        ...blockCopy[0][idx].blocksCollection.items[0],
        buttonPropsDone: {
          variant: 'primaryDark',
          label: dataTranslation['filter-news-done'],
          disabled: false,
        },
        buttonPropsClear: {
          variant: 'secondary',
          label: dataTranslation['filter-news-clear'],
          disabled: false,
        },
      };

      blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
        ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
        listTags: listTags.map((item: any) => ({
          title: dataTranslation[item?.name],
          name: item?.name,
          listSub: item?.listSub.map((sub_item: any) => ({
            title: dataTranslation[sub_item?.name],
            name: sub_item?.name,
          })),
        })),
        tagFilter: tag,
      };
    }

    if (
      section?.blocksCollection?.items[0]?.dataSource ===
      NEWS_LISTING_SOURCE.latest6MonthSalesNEvent
    ) {
      blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
        ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
        items: handleTranslateNews(dataWhatsOn, dataTranslation),
      };
    }

    if (
      section?.blocksCollection?.items[0]?.dataSource === NEWS_LISTING_SOURCE.byTipsNTricksCategory
    ) {
      blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
        ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
        items: handleTranslateNews(dataTipsAndTricks, dataTranslation),
      };
    }
  });

  const EventSection = blockCopy?.[0].splice(0, 1);
  const ScrollingNewsFilter = useMemo(() => {
    return (
      <ScrollingNewsFilterOrganisms
        data={EventSection}
        onQueryTags={v => {
          setDataQueryTags(v);
          setTitleTag('');
          setTitleGame('');
        }}
        onQueryGame={v => {
          setDataQueryGame(v);
          setTitleTag('');
          setTitleGame('');
        }}
        onActiveSlug={v=>{
          // console.log('onActiveSlugv258',v)
          setDataSlugActivate(v)
        }}
        activeSlug={gameCat}
      />
    );
  }, [JSON.stringify(tag), dataTranslation]);

  const renderTitleTab = () => {
    if (titleTag && titleTag?.length) {
      if (titleTag === '팁 유용한 정보') {
        return '팁 & 유용한 정보';
      }
      return (
        titleTag?.[0].toUpperCase() +
        titleTag
          ?.slice(1)
          ?.replace('-', ` ${dataTranslation['filter-news-and']} `)
          ?.toLocaleLowerCase()
      );
    }
    return '';
  };

  // Handle remove section when empty data
  const handleRemoveSectionWhenEmptyItem = () => {
    blockCopy[0].map((blockItem: any, idx: number) => {
      if (blockItem?.blocksCollection?.items[0]?.listItemCollection?.items.length <= 0) {
        blockCopy[0].splice(idx, 1);
      }
    });
  };
  useMemo(() => {
    handleRemoveSectionWhenEmptyItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!page) {
    return <ErrorPage statusCode={404} />;
  }

  const timeOutVerticalScrolling = () => {
    if (!!Object.keys(listTagsColor)?.length && !!Object.keys(dataTranslation)?.length) {
      return (
        <VerticalScrollingThumbnailCardOrganisms
          locale={locale}
          title={dataTranslation['news-listing-more-news']}
          listThumbnail={[]}
          handlerScroll={(cl: string, query: string[], limit: number, skip: number, game: string) =>
            handleGetDataNews(locale, query, limit, skip, game, listTagsColor, dataTranslation)
          }
        />
      );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {!titleGame ? (
        ScrollingNewsFilter
      ) : (
        <Box
          sx={{
            padding: {
              xs: '72px 0px',
              md: '80px 0px 140px 0px',
            },
          }}
        >
          <Container>
            <Typography variant="h1">{dataTranslation['nav-news-and-events']}</Typography>
          </Container>
        </Box>
      )}

      <Box>
        {isFilter &&
        (!!dataQueryTags?.length || !!dataQueryGame) &&
        !!dataFilterSelected?.length ? (
          <VerticalScrollingThumbnailCardOrganisms
            locale={locale}
            title={(titleGame || renderTitleTab()) ?? ''}
            listThumbnail={[]}
            handlerScroll={(
              cl: string,
              query: string[],
              limit: number,
              skip: number,
              game: string
            ) =>
              handleGetDataNews(
                cl,
                query,
                limit,
                skip,
                game,
                refListTagsColor.current,
                refDataTranslation.current,
                tabGame
              )
            }
            dataQueryGame={dataQueryGame}
            dataQueryTags={dataQueryTags}
            setDataFilterSelected={setDataFilterSelected}
          />
        ) : (
          <Box>
            {isFilter && (
              <NotFoundOrganisms
                title={
                  dataTranslation?.['title-news-listing-empty-state'] || 'Nothing to share yet'
                }
                description={
                  dataTranslation?.['description-news-listing-empty-state'] ||
                  'Try another game or category.'
                }
              />
            )}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: !isFilter ? 'flex' : 'none',
          flexDirection: 'column',
        }}
      >
        <BlockRenderer block={blockCopy} slug={page?.slug ?? '/'} />
        {!isFilter && <Box className="newslisting-hide">{timeOutVerticalScrolling()}</Box>}
      </Box>
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getPageData>,
    ReturnType<typeof getListNew>,
    ReturnType<typeof getListNew>
    // ReturnType<typeof getDataGlobalById>
  ] = [
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.newsFilter),
    getPageData({slug: 'news', preview}, ctx),
    getListNew(
      handleConvertToLocaleContentful(ctx.locale as string) ?? '',
      ['Event', 'Sale'],
      15,
      dateArithmetic(new Date(), -6).toISOString()
    ),
    getListNew(handleConvertToLocaleContentful(ctx.locale as string) ?? '', ['Tips and tricks'], 8),
  ];
  const [listTags, pageData, getListWhatOne, dataTipsAndTricks] = await Promise.all(promises);
  const {data} = pageData;

  const page = data?.pageCollection?.items[0];
  if (!page) {
    return {
      redirect: {
        destination: `/${ctx.locale}/404`,
        permanent: false,
      },
    };
  } else {
    return {
      props: {
        listTags: listTags ?? [],
        data,
        dataWhatsOn: getListWhatOne?.items ?? [],
        dataTipsAndTricks: dataTipsAndTricks?.items ?? [],
        locale: ctx?.locale,
      },
      revalidate: 60,
    };
  }
};

export default News;
